module.exports = "pegasus_template/assets/two-row-image-text-preview.png";